/**
 * Returns true when payment method represents a check/cheque payment.
 * Pay Bill stores "Check"; other flows may use "Cheque".
 */
export function isCheckPaymentMethod(method) {
  if (!method) return false;
  const normalized = String(method).trim().toLowerCase();
  return normalized === 'check' || normalized === 'cheque';
}
